import { cn as t } from "../../utils/utils.js";
import { jsx as o } from "react/jsx-runtime";
import * as r from "@radix-ui/react-label";
function s({ className: e, ...a }) {
  return /* @__PURE__ */ o(r.Root, {
    "data-slot": "label",
    className: t("flex items-center gap-2 select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50", e),
    ...a
  });
}
export {
  s as Label
};

//# sourceMappingURL=label.js.map